<template>
  <div class="page">
    <div class="filter-bar">
      <span @click="select">
        日期
        {{ value }}
        <i class="caret"></i>
      </span>
      <span @click="closeModal" class="icon-close">
        <i class="iconfont close"></i>
      </span>
    </div>
    <div class="schedule-container">
      <div class="schedule-header">
        <span class="time-label-header">时间/人员</span>
        <div class="time-axis" ref="scrollContainer" @scroll="handleScroll">
          <div v-for="(hour, index) in timeList" :key="index" class="time-slot">
            <span>{{ hour.start }}</span
            >~
            <span>{{ hour.end }}</span>
          </div>
        </div>
      </div>

      <div class="schedule-content">
        <div class="persons-header" :style="{ width: personsHeade + 'px' }">
          <span
            v-for="item in persons"
            :key="item.id"
            class="person-header-item"
          >
            {{ item.name }}
          </span>
        </div>

        <div
          class="persons-container"
          :style="{ width: personsHeade + 'px' }"
          ref="scrollContainerTow"
          @scroll="handleScrollTow"
        >
          <div
            class="time-slot-color"
            :style="{
              background:
                isColor == 1 ? 'rgba(60,179,113,0.2)' : 'rgba(255,165,0,0.2)',
              width: personsHeade + 'px',
              height: isColorHeight + 'px',
              top: isColorTop + 'px',
            }"
          ></div>

          <div
            v-for="(meet, index) in meetings"
            :key="index"
            class="meeting-item"
            :style="{
              fontSize: '12px',
              color: '#646A76',
              background: '#EFF0F1',
              height: meetingTimeHeight(meet),
              top: meetingTimeTop(meet),
              'z-index': index,
              left: meetingTimeLeft(meet),
            }"
          >
            <span>{{ meet.title }}</span>
            <span>{{ meet.start + "~" + meet.end }}</span>
          </div>
          <div
            v-for="hour in timeList"
            :key="hour.start"
            class="persons-header"
          >
            <span
              v-for="person in persons"
              :key="person.id"
              class="person-content-item"
            >
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: {
    params: Object,
  },
  data() {
    return {
      value: "",
      personsHeade: 273,
      timeList: [
        {
          start: "00:00",
          end: "01:00",
          isColor: 0,
        },
        {
          start: "01:00",
          end: "02:00",
          isColor: 0,
        },
        {
          start: "02:00",
          end: "03:00",
          isColor: 0,
        },
        {
          start: "03:00",
          end: "04:00",
          isColor: 0,
        },
        {
          start: "04:00",
          end: "05:00",
          isColor: 0,
        },
        {
          start: "05:00",
          end: "06:00",
          isColor: 0,
        },
        {
          start: "06:00",
          end: "07:00",
          isColor: 0,
        },
        {
          start: "07:00",
          end: "08:00",
          isColor: 0,
        },
        {
          start: "08:00",
          end: "09:00",
          isColor: 0,
        },
        {
          start: "09:00",
          end: "10:00",
          isColor: 0,
        },
        {
          start: "10:00",
          end: "11:00",
          isColor: 0,
        },
        {
          start: "11:00",
          end: "12:00",
          isColor: 0,
        },
        {
          start: "12:00",
          end: "13:00",
          isColor: 0,
        },
        {
          start: "13:00",
          end: "14:00",
          isColor: 0,
        },
        {
          start: "14:00",
          end: "15:00",
          isColor: 0,
        },
        {
          start: "15:00",
          end: "16:00",
          isColor: 0,
        },
        {
          start: "16:00",
          end: "17:00",
          isColor: 0,
        },
        {
          start: "17:00",
          end: "18:00",
          isColor: 0,
        },
        {
          start: "18:00",
          end: "19:00",
          isColor: 0,
        },
        {
          start: "19:00",
          end: "20:00",
          isColor: 0,
        },
        {
          start: "20:00",
          end: "21:00",
          isColor: 0,
        },
        {
          start: "21:00",
          end: "22:00",
          isColor: 0,
        },
        {
          start: "22:00",
          end: "23:00",
          isColor: 0,
        },
        {
          start: "23:00",
          end: "00:00",
          isColor: 0,
        },
      ],
      isColorHeight: 0,
      isColorTop: 100,
      isColor: 0,
      indexNum: 0,
      persons: [],
      personsList: [],
      currentTime: [],
      meetings: [],
    };
  },

  mounted() {
    this.value = this.dateFormat(
      new Date(this.params.main.me_date),
      "yyyy-MM-dd"
    );

    this.getData(this.value);
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    getData(date) {
      let me = this,
        ids = me.params.main.me_emids;
      me.meetings = [];
      me.personsList = [];
      me.$loading({
        url: "/api/oa/meeting/getEmStatusDate",
        params: {
          emids: ids,
          date: me.dateFormat(new Date(date), "yyyy-MM-dd"),
        },
      }).then(function (res) {
        if (res.success) {
          me.personsList = res.data ? res.data : [];
          me.persons = me.personsList.map((item) => {
            return {
              id: item.emid,
              name: item.emname,
              meetingDTOS: item.meetingDTOS,
            };
          });

          me.personsList.map((items) => {
            items.meetingDTOS.map((item) => {
              me.meetings.push({
                id: items.emid,
                name: items.emname,
                title: item.me_title,
                start: item.me_start,
                end: item.me_over,
              });
            });
          });
          if (me.persons.length * 91 > me.personsHeade) {
            me.personsHeade = me.persons.length * 91;
          }
          if (!me.indexNum) {
            me.updateCurrentTime(me.meetings);
            me.indexNum = 1;
          }
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    },
    handleScroll() {
      const container = this.$refs.scrollContainer;
      this.$refs.scrollContainerTow.scrollTop = container.scrollTop;
    },
    handleScrollTow() {
      const container = this.$refs.scrollContainerTow;
      this.$refs.scrollContainer.scrollTop = container.scrollTop;
    },

    meetingTimeHeight(data) {
      let height = 0;
      let start = [
        Number(data.start.slice(0, data.start.indexOf(":"))),
        Number(
          data.start.slice(data.start.indexOf(":") + 1, data.start.length)
        ),
      ];
      let end = [
        Number(data.end.slice(0, data.end.indexOf(":"))),
        Number(data.end.slice(data.end.indexOf(":") + 1, data.end.length)),
      ];
      if (start[0] == 23) {
        if (start[1] > 0) {
          height = start[1];
        } else {
          height = 60;
        }
      } else {
        if (start[0] == end[0]) {
          height = end[1] - start[1];
        } else if (start[0] < end[0]) {
          height = (end[0] - start[0]) * 60;
          if (start[1] > end[1]) {
            height = height - (start[1] - end[1]);
          } else {
            height = height + (end[1] - start[1]);
          }
        }
      }

      return height + "px";
    },
    meetingTimeTop(data) {
      let top = 0;
      let start = [
        Number(data.start.slice(0, data.start.indexOf(":"))),
        Number(
          data.start.slice(data.start.indexOf(":") + 1, data.start.length)
        ),
      ];
      top = start[0] * 60.8 + start[1];
      return top + "px";
    },
    meetingTimeLeft(data) {
      let me = this;
      let left = 0;
      let num;
      me.persons.map((item, index) => {
        if (item.name == data.name) {
          num = index;
        }
      });
      left = num * 90.8;
      return left + "px";
    },

    select() {
      var me = this,
        date = me.value ? new Date(me.value.replace(/-/g, "/")) : new Date(),
        year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate();
      me.currentTime = [];
      me.$weui.datePicker({
        defaultValue: [year, month, day],
        onConfirm: function (r) {
          var date = new Date(r[0].value, r[1].value - 1, r[2].value),
            val = me.dateFormat(date, "yyyy-MM-dd");
          me.value = val;
          me.getData(me.value);
        },
      });
    },

    updateCurrentTime(list) {
      let me = this;
      me.currentTime.push(me.params.main.me_start);
      me.currentTime.push(me.params.main.me_over);
      let startIndex = me.currentTime[0].indexOf(":");
      let endIndex = me.currentTime[1].indexOf(":");
      let itemStart = [
          Number(me.currentTime[0].slice(0, startIndex)),
          Number(me.currentTime[0].slice(startIndex + 1, 5)),
        ],
        itemEnd = [
          Number(me.currentTime[1].slice(0, endIndex)),
          Number(me.currentTime[1].slice(endIndex + 1, 5)),
        ];

      me.isColor = 1;
      me.isColorTop = itemStart[0] * 60.8 + itemStart[1];
      // me.isColorHeight = (itemEnd[0] - itemStart[0]) * 60;
      if (itemStart[0] < itemEnd[0]) {
        me.isColorHeight = me.isColorHeight + (itemEnd[0] - itemStart[0]) * 60;
        if (itemStart[1] < itemEnd[1]) {
          me.isColorHeight = me.isColorHeight + (itemEnd[1] - itemStart[1]);
        } else {
          me.isColorHeight = me.isColorHeight - (itemStart[1] - itemEnd[1]);
        }
      } else if (itemStart[0] == itemEnd[0]) {
        me.isColorHeight = me.isColorHeight + (itemEnd[1] - itemStart[1]);
      } else if (itemStart[0] > itemEnd[0]) {
        if (itemStart[1]) {
          me.isColorHeight = itemStart[1];
        } else {
          me.isColorHeight = 60;
        }
      }
      list.map((item) => {
        let start = [
          Number(item.start.slice(0, item.start.indexOf(":"))),
          Number(
            item.start.slice(item.start.indexOf(":") + 1, item.start.length)
          ),
        ];
        let end = [
          Number(item.end.slice(0, item.end.indexOf(":"))),
          Number(item.end.slice(item.end.indexOf(":") + 1, item.end.length)),
        ];
        if (itemStart[0] >= start[0] && itemStart[0] <= end[0]) {
          if (itemStart[1] < start[1]) {
            me.isColor = 2;
          }
        }
        if (itemEnd[0] >= start[0] && itemStart[0] <= start[0] && itemEnd[1] > start[1]) {
          me.isColor = 2;
        }
        if (itemStart[0] >= start[0] && itemEnd[0] <= end[0]) {
          me.isColor = 2;
        }
      });
    },
  },
};
</script>
<style scoped>
.icon-close {
  font-size: 12px;
  color: #999;
}
.filter-bar {
  height: 50px;
  background: var(--weui-BG-2);
  margin-bottom: 10px !important;
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.schedule-container {
  width: 100%;
  height: calc(100% - 60px);
  background: white;
  display: flex;
}
.schedule-header {
  width: 100px;
  height: calc(100% - 1.5px);
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #eaeaea;
  background: #f9fafc;
  position: relative;
}

.time-label-header {
  width: 100px;
  height: 60px;
  font-size: 14px;
  line-height: 60px;
  text-align: center;
  font-weight: 600;
  color: #5c6bc0;
  border-bottom: 1px solid #eaeaea;
  display: inline-block;
}
.persons-header {
  height: 60px;
  display: flex;
  border-bottom: 1px solid #eaeaea;
}
.person-header-item {
  display: inline-block;
  width: 90px;
  height: 60px;
  font-size: 12px;
  line-height: 60px;
  text-align: center;
  /* border-bottom: 1px solid #eaeaea; */
  border-right: 1px solid #eaeaea;
}
.person-content-item {
  /* display: inline-block; */
  width: 90px;
  height: 60px;
  font-size: 12px;
  line-height: 30px;
  text-align: center;
  /* border-bottom: 1px solid #eaeaea; */
  border-right: 1px solid #eaeaea;
  position: relative;
}
.meeting-item {
  position: absolute;
  width: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.person-header {
  min-width: 180px;
  padding: 15px 10px;
  text-align: center;
  font-weight: 600;
  color: #5c6bc0;
  border-left: 1px solid #eaeaea;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.person-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #5c6bc0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  margin-bottom: 8px;
}
.schedule-content {
  width: calc(100% - 100px);
  height: calc(100% - 1.5px);
  display: block !important;
  position: relative;
  overflow-x: scroll;
}
.time-axis {
  width: 100px;
  height: calc(100% - 1.5px);
  /* flex-shrink: 0; */
  background: #f9fafc;
  overflow-y: scroll;
}
.time-slot {
  display: inline-block;
  width: 100px;
  height: 60px;
  font-size: 14px;
  line-height: 60px;
  text-align: center;
  border-bottom: 1px solid #eaeaea;
}
.time-slot-color {
  position: absolute;
  border-radius: 5px;
  left: 0px;
  top: 60px;
  z-index: 30;
}

.persons-container {
  height: calc(100% - 61.5px);
  overflow-y: scroll;
  position: relative;
  /* display: flex;
  flex: 1; */
  /* overflow-x: auto; */
}

.filter-bar {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
  padding: 15px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
</style>